import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, useLocation } from 'react-router-dom';
import Item from 'antd/lib/list/Item';
import styles from './ZtAppList.module.less';
import Rate from '../../components/Rate/Rate';
import AButton from '../../components/AButton/AButton';
import Button from '../../components/Button/Button';
import { CONTEXT } from '../../config';
import { logPostInfo } from '../../actions/log';
import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);

  const [showData, setShowData] = useState({});
  const LOG_ACTION_SOURCE = {
    source: `${logInfo.tag}`,
  };

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.content && data.content.apps) {
      setShowData(data);
    }
  }, [dispatch, data]);

  const handleSoftCard = useCallback(() => {
    dispatch(
      logPostInfo({
        source_p: LOG_ACTION_SOURCE.source,
        source_pp: logInfoData.source_p,
        ...logInfo,
      }),
    );
  }, [dispatch]);

  const SoftCard = ({ appInfo }) => {
    return appInfo ? (
      <div
        className={styles.card_item}
        data-softtag={appInfo.androidType !== '1' ? appInfo.softID : appInfo.packageName}
      >
        <div className={styles.card_logo}>
          <Link
            className={styles.content_line_title}
            to={
              appInfo.androidType !== '1'
                ? `${CONTEXT}/detail/soft/${appInfo.softID || ''}/{}`
                : `${CONTEXT}/adetail/${appInfo.packageName || ''}/${
                    appInfo.versionCode
                  }/${appInfo.bizInfo || '{}'}`
            }
            onClick={() => {
              handleSoftCard();
            }}
          >
            <img className={styles.card_logo_img} src={appInfo.logoFile} alt="logo" />
          </Link>
          {appInfo.androidType === '1' && <div className={styles.card_logo_alogo} />}
        </div>
        <div className={styles.card_content}>
          <div className={styles.content_line}>
            <Link
              className={styles.content_line_title}
              to={
                appInfo.androidType !== '1'
                  ? `${CONTEXT}/detail/soft/${appInfo.softID || ''}/{}`
                  : `${CONTEXT}/adetail/${appInfo.packageName || ''}/${
                      appInfo.versionCode
                    }/${appInfo.bizInfo || '{}'}`
              }
              onClick={() => {
                handleSoftCard();
              }}
            >
              {appInfo.softName}
            </Link>
          </div>
          <div className={styles.content_line}>
            {appInfo.downloadCount && (
              <span className={styles.content_line_item}>{appInfo.downloadCount}安装</span>
            )}
            <span className={styles.content_line_item}>{appInfo.installFileSize}</span>
          </div>
          <div className={styles.content_line}>
            <span className={styles.content_line_info}>{appInfo.introduction}</span>
          </div>
        </div>
        <div className={styles.card_button}>
          {appInfo.androidType === '1' ? (
            <AButton
              soft={{ ...appInfo, bizInfo: showData.bizInfo }}
              info={{
                className: styles.soft_btn,
                className_busing: styles.soft_btn_busing,
                className_open: styles.soft_button_open,
              }}
              logInfo={{ source: `ZT||${getQueryString('ztId', location.search)}` }}
            />
          ) : (
            <Button
              soft={{ ...appInfo, bizInfo: showData.bizInfo }}
              info={{
                className: styles.soft_btn,
                className_busing: styles.soft_btn_busing,
                className_open: styles.soft_button_open,
              }}
              logInfo={{ source: `ZT||${getQueryString('ztId', location.search)}` }}
            />
          )}
        </div>
      </div>
    ) : (
      ''
    );
  };
  return (
    showData &&
    showData.content &&
    showData.content.apps && (
      <div className={styles.card}>
        {showData.content.apps.map((item, index) => (
          <SoftCard key={index} appInfo={item} />
        ))}
      </div>
    )
  );
});
